import respondence from './respondence'
import knowledge from './knowledge'
import question from './question'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    respondence,
    knowledge,
    question,
  }
}
